var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiInsightSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 5.83333L7.90333 6.995C7.34 8.51833 7.05833 9.28 6.5025 9.83583C5.94667 10.3917 5.185 10.6733 3.66167 11.2367L2.5 11.6667L3.66167 12.0967C5.185 12.66 5.94667 12.9425 6.5025 13.4975C7.05833 14.0525 7.34 14.815 7.90333 16.3383L8.33333 17.5L8.76333 16.3383C9.32667 14.815 9.60917 14.0533 10.1642 13.4975C10.7192 12.9417 11.4817 12.66 13.005 12.0967L14.1667 11.6667L13.005 11.2367C11.4817 10.6733 10.72 10.3917 10.1642 9.83583C9.60833 9.28 9.32667 8.51833 8.76333 6.995L8.33333 5.83333ZM15 2.5L14.8158 2.9975C14.5742 3.65083 14.4533 3.9775 14.2158 4.215C13.9775 4.45333 13.6508 4.57417 12.9975 4.815L12.5 5L12.9983 5.18417C13.6508 5.42583 13.9775 5.54667 14.215 5.78417C14.4533 6.0225 14.5742 6.34917 14.815 7.0025L15 7.5L15.1842 7.0025C15.4258 6.34917 15.5467 6.0225 15.7842 5.785C16.0225 5.54667 16.3492 5.42583 17.0025 5.185L17.5 5L17.0017 4.81583C16.3492 4.57417 16.0225 4.45333 15.785 4.21583C15.5467 3.9775 15.4258 3.65083 15.185 2.9975L15 2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiInsightSparkle);
export default __webpack_public_path__ + "static/media/AIInsightSparkle.275f999425bab89a7174327205d1c8cd.svg";
export { ForwardRef as ReactComponent };